import { selectRuntimeManifest } from '@pokerroom/branding/browser';
import { brand } from './lib/brand';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { DesignBoundary } from './components/layout/DesignBoundary';
import './styles/globals.css';
import './lib/i18n'; // 初始化 i18next（side-effect import）
import { loadCustomTermsOverride } from './lib/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

// 啟動時載入 DB 層術語覆蓋
loadCustomTermsOverride().catch((err) => {
  console.warn('[i18n] Failed to load custom terms:', err);
});

void selectRuntimeManifest('web', brand);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DesignBoundary>
          <App />
        </DesignBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
